export const AllUtility = {
  SalesOrg: '1000',
  Division: '01',
  DistrChannel: '07',
  COArea: '1000',
} as const;

export const AllWolf = {
  SalesOrg: '6000',
  Division: '07',
  DistrChannel: '00',
  COArea: '1000',
} as const;
